<template>
  <div class="sign_in">

    <div class="adorn"></div>

    <div class="signinf">
      <div class="info">
        <h1><img src="../assets/logo_mini.png" />恩琦运输管理系统</h1>
        <el-tabs v-model="activeName" stretch>

          <el-tab-pane label="" name="first">
            <el-form class="entry" ref="loginForm" :model="form" :rules="rules" label-width="0">
              <el-form-item prop="username">
                <el-input placeholder="请填写用户名" v-model="form.username">
                  <!-- <i slot="prefix" class="el-input__icon el-icon-user"></i> -->
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input placeholder="请填写密码" v-model="form.password" show-password>
                  <!-- <i slot="prefix" class="el-input__icon el-icon-lock"></i> -->
                </el-input>
              </el-form-item>
            </el-form>

            <!--滑块验证-->
            <div class="verStorage">
              <span>验证:</span>
              <div class="drag" ref="dragDiv">
                <div class="drag_bg"></div>
                <div class="drag_text">{{ confirmWords }}</div>
                <div ref="moveDiv" @mousedown="mouseDownFn($event)" :class="{ handler_ok_bg: confirmSuccess }"
                  class="handler handler_bg" style="position: absolute; top: -2px; left: 0px"></div>
              </div>
            </div>

            <el-button type="primary" class="subbtn" @click="loginValidate('loginForm')">点击登录</el-button>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Login",
  props: {
    msg: String,
  },
  data() {
    return {
      form: {
        username: null,
        password: null,
      },
      forms: {
        phone: null,
        code: null,
      },
      btnTitle: '获取验证码',
      rules: {
        username: [{ required: true, message: "请填写用户名", trigger: "blur" }],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请填写手机号", trigger: "blur" }],
        code: [{ required: true, message: "请填写验证码", trigger: "blur" }],
      },
      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveState: false /*触发拖动状态  判断*/,
      maxWidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: "按住滑块，拖动到最右边" /*滑块文字*/,
      confirmSuccess: false /*验证成功判断*/,
      statestatus: false,
      activeName: 'first',
      isClick: true,
      showCode: true
    };
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    logReq() {
      this.post('login/dologin', this.form, ({ user, msg }) => {
        if (user && user.id) {
          console.log({ ...user });
          this.setUserInfo(user);
          let path = 'index'
          const { user_group_id } = user
          if ([2, 3, 4].includes(user_group_id)) {
            // 主管会计、分管会计、出纳
            path = 'order'
          } else if (user_group_id == 5) {
            path = 'order'
          } else if (user_group_id == 6) {
            path = 'fix'
          } else if (user_group_id == 7) {
            path = 'vehicle'
          } else if (user_group_id == 12) {
            path = 'contract'
          } else if (user_group_id == 16) {
            path = 'fix/repairlist'
          }
          this.$nextTick(() => {
            this.$router.push(path)
          })
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      })
    },
    getCode() {
      if (!this.forms.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号!',
        });
        return
      }
      if (!/^[1]([3-9])[0-9]{9}$/.test(this.forms.phone)) {
        this.$message({
          type: 'error',
          message: '请填写正确的手机号!',
        });
        return
      }
      if (this.isClick) {
        this.post('login/getcode', { phone: this.forms.phone }, ({ msg }) => {
          if (msg == 'ok') {
            this.showCode = false
            console.log(111)
            this.isClick = false
            let s = 60
            this.btnTitle = s + 's'
            let interval = setInterval(() => {
              s--
              this.btnTitle = s + 's'
              if (s < 0) {
                this.btnTitle = '重新获取'
                this.isClick = true
                clearInterval(interval)
              }
            }, 1000);
            // console.log(res)
          } else {
            this.$message({
              type: 'error',
              message: msg,
            });
          }
        })
      }

    },
    loginValidate(fname) {
      console.log({ ...this.form });
      // console.log(this.$refs);
      this.$refs[fname].validate((valid) => {
        console.log(valid);
        if (valid) {
          if (!this.statestatus) {
            this.$message.error("请划动验证");
            return;
          }
          this.logReq()
        }
      });
      // const { username, password } = this.form;
      // if (!username) {
      //   this.$message.error("请填写用户名");
      //   return;
      // } else if (!password) {
      //   this.$message.error("请填写密码");
      //   return;
      // } else if (!this.statestatus) {
      //   this.$message.error("请划动验证");
      //   return;
      // }
      // console.log("成功");
      // setTimeout(() => {
      //   this.$router.push('/admin')
      // }, 3000);
    },
    //mousedown 事件
    mouseDownFn: function (e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
        this.mouseMoveState = true;
        this.beginClientX = e.clientX;
      }
    },
    //验证成功函数
    successFunction() {
      this.statestatus = true;
      // this.$store.commit("statestatus", true);
      this.confirmSuccess = true;
      this.confirmWords = "验证通过";
      if (window.addEventListener) {
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("mousemove", this.mouseMoveFn);
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("mouseup", this.moseUpFn);
      } else {
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("mouseup", () => { });
      }
      const drag_text = document.getElementsByClassName("drag_text")[0];
      drag_text.style.color = "#fff";
      drag_text.style.padding = "0 80px 0 0";
      document.getElementsByClassName("handler")[0].style.left =
        this.maxWidth + "px";
      document.getElementsByClassName("drag_bg")[0].style.width =
        this.maxWidth + "px";
    },
    //mousemove事件
    mouseMoveFn(e) {
      if (this.mouseMoveState) {
        let width = e.clientX - this.beginClientX;
        if (width > 0 && width <= this.maxWidth) {
          document.getElementsByClassName("handler")[0].style.left =
            width + "px";
          document.getElementsByClassName("drag_bg")[0].style.width =
            width + "px";
        } else if (width > this.maxWidth) {
          this.successFunction();
        }
      }
    },
    //mouseup事件
    moseUpFn(e) {
      this.mouseMoveState = false;
      var width = e.clientX - this.beginClientX;
      if (width < this.maxWidth) {
        document.getElementsByClassName("handler")[0].style.left = 0 + "px";
        document.getElementsByClassName("drag_bg")[0].style.width = 0 + "px";
      }
    },
  },
  mounted() {
    let styleDragDiv = window.getComputedStyle(this.$refs.dragDiv);
    let widthDragDiv = parseFloat(styleDragDiv.getPropertyValue('width'));

    let styleMoveDiv = window.getComputedStyle(this.$refs.moveDiv);
    let widthMoveDiv = parseFloat(styleMoveDiv.getPropertyValue('width'));

    this.maxWidth = widthDragDiv - widthMoveDiv;

    document
      .getElementsByTagName("html")[0]
      .addEventListener("mousemove", this.mouseMoveFn);
    document
      .getElementsByTagName("html")[0]
      .addEventListener("mouseup", this.moseUpFn);
  },
};
</script>

<style scoped>
/deep/.el-tabs__header {
  display: none;
}

.sign_in {
  position: relative;
  z-index: 99;
  height: 100vh;
  background: url(../assets/icon_sign_bg.png) no-repeat top center;
  background-size: 100%;
}

.sign_in .logo {
  position: absolute;
  left: 80px;
  top: 50px;
  height: 35px;
  overflow: hidden;
}

.sign_in .logo .img {
  float: left;
  width: 30px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  overflow: hidden;
}

.sign_in .logo .img img {
  max-width: 100%;
  vertical-align: middle;
}

.sign_in .logo h1 {
  float: left;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  margin: 0 0 0 10px;
  font-weight: normal;
  font-size: 20px;
  color: #333;
}

.sign_in .adorn {
  position: absolute;
  left: 100px;
  top: 20%;
  width: 40%;
  height: 500px;
  overflow: hidden;
  background: url(../assets/icon_adorn.png) no-repeat center center;
  background-size: 90%;
}

.sign_in .signinf {
  position: absolute;
  right: 8%;
  top: 0;
  width: 60%;
  height: auto;
  overflow: hidden;
}

.sign_in .signinf .info {
  float: right;
  width: 400px;
  padding: 0 50px;
  height: auto;
  overflow: hidden;
  margin: 20% 40px 40px 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 0px 40px rgb(0 50 149 / 10%);
  -moz-box-shadow: 0px 0px 40px rgba(0, 50, 149, 0.1);
  -webkit-box-shadow: 0px 0px 40px rgb(0 50 149 / 10%);
}

.signinf .info h1 {
  text-align: center;
  overflow: hidden;
  margin: 35px auto 30px;
  font-weight: normal;
  font-weight: bold;
  font-size: 24px;
  color: #555555;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signinf .info .entry {
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}

.signinf .info .entry .el-input {
  margin: 0 auto 10px;
}

.signinf .info .entry>>>.el-input__inner {
  height: 59px;
  line-height: 59px;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #dcdfe6;
  font-size: 16px;
  color: #333;
}

.signinf .info .entry>>>.el-input--prefix .el-input__inner {
  padding-left: 40px;
}

.signinf .info .entry>>>.el-input__prefix {
  font-size: 22px;
}

.signinf .info .entry>>>.el-input__suffix .el-icon-view {
  font-size: 18px;
}

.signinf .info .entry>>>.el-input__suffix {
  top: 9px;
}

.signinf .info .entry>>>.el-input__suffix .cb {
  width: 78px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
  font-size: 12px;
  color: #ccc;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  padding: 0;
}

.signinf .info .entry>>>.el-input__suffix .cbs {
  width: 78px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
  font-size: 12px;
  color: #3e82fe;
  border: 1px solid #3e82fe;
  border-radius: 5px;
  background: #fff;
  padding: 0;
}


/*滑块验证*/
.verStorage {
  display: flex;
  display: -webkit-flex;
  height: 50px;
  line-height: 50px;
  margin: 15px auto 0;
}

.verStorage span {
  width: 55px;
  font-size: 16px;
  color: #333;
}

.drag {
  flex: 1;
  position: relative;
  background-color: #f2f2f2;
  /* 之前是100%宽度 滑动验证那拿不到宽度 改成了具体像素 */
  width: 345px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  border-radius: 5px;
}

.handler {
  width: 80px;
  height: 50px;
  border-radius: 5px;
  cursor: move;
  background: #fff;
  box-shadow: 0px 0px 15px rgb(0 50 149 / 15%);
  -moz-box-shadow: 0px 0px 15px rgba(0, 50, 149, 0.15);
  -webkit-box-shadow: 0px 0px 15px rgb(0 50 149 / 15%);
}

.handler_bg {
  background: #fff url(../assets/icon_verify.png) no-repeat center center;
  background-size: 30px;
}

.handler_ok_bg {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background: #fff url(../assets/icon_succ_01.png) no-repeat center center;
  background-size: 30px;
}

.drag_bg {
  background-color: #3e82fe;
  height: 46px;
  width: 0px;
  border-radius: 5px 0 0 5px;
}

.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
  font-size: 16px;
  color: #999;
  padding-left: 80px;
  box-sizing: border-box;
}

.signinf .info .subbtn {
  display: block;
  width: 100%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  overflow: hidden;
  margin: 40px auto 40px;
  padding: 0;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
  background: #3e82fe;
}
</style>